module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0134.jpg?v=9d1aba14";